import { render } from "./quadro.vue?vue&type=template&id=12e5e7c4&scoped=true"
import script from "./quadro.vue?vue&type=script&lang=js"
export * from "./quadro.vue?vue&type=script&lang=js"

import "./quadro.vue?vue&type=style&index=0&id=12e5e7c4&scoped=true&lang=css"

import exportComponent from "/var/deploy/production_one/web_head/releases/20260324180918/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e5e7c4"]])

export default __exports__